var _defs, _rect, _circle, _circle2, _rect2, _circle3, _circle4, _circle5, _rect3, _rect4, _path, _text, _text2, _rect5, _circle6, _text3, _rect6, _circle7, _circle8, _circle9, _rect7, _path2, _g, _rect8, _text4, _text5, _rect9, _text6, _text7, _text8, _text9, _text10, _line, _text11, _text12, _rect10, _circle10, _text13, _rect11, _text14, _rect12, _circle11, _text15, _rect13, _text16, _circle12, _text17, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantVoiceAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    width: 1280,
    height: 720,
    fontFamily: "'Segoe UI','Helvetica Neue',Arial,sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rbg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a1420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d1c2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voice",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2dd4bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c5cf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teal",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2dd4bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38bdf8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rglow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2dd4bf",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2dd4bf",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#rbg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 360,
    r: 300,
    fill: "url(#rglow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 150,
    r: 220,
    fill: "url(#rglow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 92,
    width: 1040,
    height: 536,
    rx: 24,
    fill: "#0b1a2b",
    stroke: "#1c3550",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 126,
    r: 6,
    fill: "#ff5f56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 126,
    r: 6,
    fill: "#ffbd2e"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 126,
    r: 6,
    fill: "#27c93f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 160,
    width: 46,
    height: 46,
    rx: 12,
    fill: "url(#voice)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 172,
    width: 12,
    height: 18,
    rx: 6,
    fill: "#0a1420"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 186 a11 11 0 0 0 22 0 M175 197 v6",
    stroke: "#0a1420",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 212,
    y: 182,
    fill: "#ffffff",
    fontSize: 25,
    fontWeight: 700
  }, "AI Restaurant Voice Assistant")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 213,
    y: 203,
    fill: "#7f9bb8",
    fontSize: 14
  }, "Voice-first ordering &amp; live operations control")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 168,
    width: 130,
    height: 34,
    rx: 17,
    fill: "#0c2a1c",
    stroke: "#1f6f43"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1022,
    cy: 185,
    r: 5,
    fill: "#34d399"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1036,
    y: 190,
    fill: "#5fe0a0",
    fontSize: 13,
    fontWeight: 600
  }, "OPEN")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 232,
    width: 470,
    height: 330,
    rx: 16,
    fill: "#07131f",
    stroke: "#16304a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 387,
    cy: 330,
    r: 110,
    fill: "none",
    stroke: "#2dd4bf",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 387,
    cy: 330,
    r: 88,
    fill: "none",
    stroke: "#2dd4bf",
    strokeOpacity: 0.22,
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 387,
    cy: 330,
    r: 64,
    fill: "url(#voice)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 306,
    width: 18,
    height: 30,
    rx: 9,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366 332 a21 21 0 0 0 42 0 M387 353 v12 M375 368 h24",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2dd4bf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 438,
    width: 6,
    height: 16,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 430,
    width: 6,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 420,
    width: 6,
    height: 34,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 410,
    width: 6,
    height: 44,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 424,
    width: 6,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 404,
    width: 6,
    height: 50,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 416,
    width: 6,
    height: 38,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 402,
    width: 6,
    height: 52,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 422,
    width: 6,
    height: 32,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 412,
    width: 6,
    height: 42,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 428,
    width: 6,
    height: 26,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 436,
    width: 6,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 432,
    width: 6,
    height: 22,
    rx: 3
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 482,
    width: 422,
    height: 60,
    rx: 12,
    fill: "#0e2233",
    stroke: "#1c3f57"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 507,
    fill: "#8fb0cf",
    fontSize: 11,
    letterSpacing: 1
  }, "CUSTOMER \xB7 SPEAKING")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 528,
    fill: "#eaf4ff",
    fontSize: 14,
    fontWeight: 600
  }, "\u201CTwo Zinger Burgers and a Coke\u201D")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 232,
    width: 360,
    height: 228,
    rx: 16,
    fill: "#102237",
    stroke: "#1e3a5f"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 264,
    fill: "#7f9bb8",
    fontSize: 12,
    letterSpacing: 1.5
  }, "LIVE ORDER")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 300,
    fill: "#eaf2ff",
    fontSize: 15,
    fontWeight: 600
  }, "2\xD7 Zinger Burger")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 984,
    y: 300,
    fill: "#cfe0f2",
    fontSize: 15,
    textAnchor: "end"
  }, "$11.98")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 332,
    fill: "#eaf2ff",
    fontSize: 15,
    fontWeight: 600
  }, "1\xD7 Coca-Cola")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 984,
    y: 332,
    fill: "#cfe0f2",
    fontSize: 15,
    textAnchor: "end"
  }, "$1.99")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 672,
    y1: 352,
    x2: 984,
    y2: 352,
    stroke: "#ffffff",
    strokeOpacity: 0.08
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 390,
    fill: "#ffffff",
    fontSize: 17,
    fontWeight: 700
  }, "Total")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 984,
    y: 392,
    fill: "#5fe0c8",
    fontSize: 22,
    fontWeight: 800,
    textAnchor: "end"
  }, "$13.97")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 412,
    width: 150,
    height: 30,
    rx: 15,
    fill: "#33270f",
    stroke: "#a8781f"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 427,
    r: 4,
    fill: "#f6a94b"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 702,
    y: 432,
    fill: "#ffcf8a",
    fontSize: 12.5,
    fontWeight: 600
  }, "Order building\u2026")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 476,
    width: 174,
    height: 66,
    rx: 14,
    fill: "#102237",
    stroke: "#1e3a5f"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 504,
    fill: "#7f9bb8",
    fontSize: 11,
    letterSpacing: 1
  }, "STATUS")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 512,
    width: 44,
    height: 20,
    rx: 10,
    fill: "#1f6f43"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 702,
    cy: 522,
    r: 8,
    fill: "#5fe0a0"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 527,
    fill: "#eaf2ff",
    fontSize: 13,
    fontWeight: 600
  }, "Open")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 476,
    width: 174,
    height: 66,
    rx: 14,
    fill: "#102237",
    stroke: "#1e3a5f"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 854,
    y: 504,
    fill: "#7f9bb8",
    fontSize: 11,
    letterSpacing: 1
  }, "AI VOICE")), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 524,
    r: 6,
    fill: "#7c5cf0"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 876,
    y: 529,
    fill: "#eaf2ff",
    fontSize: 13,
    fontWeight: 600
  }, "ElevenLabs \xB7 Rachel")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 574,
    width: 96,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "LangGraph"), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 574,
    width: 78,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 299,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "LiveKit"), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 574,
    width: 132,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 416,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "Groq \xB7 Llama 3.1"), /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 574,
    width: 98,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 543,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "Deepgram"), /*#__PURE__*/React.createElement("rect", {
    x: 604,
    y: 574,
    width: 104,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 656,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "ElevenLabs"), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 574,
    width: 84,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 762,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "FastAPI"), /*#__PURE__*/React.createElement("rect", {
    x: 816,
    y: 574,
    width: 72,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 852,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "React"), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 574,
    width: 98,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 949,
    y: 594,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "Supabase"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantVoiceAi);
export default __webpack_public_path__ + "static/media/restaurant-voice-ai.d128dc144ab13eac903d47e9edf86ab5.svg";
export { ForwardRef as ReactComponent };